export const GET_PAYOUT_TRACKER_PAGE_START = 'GET_PAYOUT_TRACKER_PAGE_START';
export const GET_PAYOUT_TRACKER_PAGE_SUCCESS = 'GET_PAYOUT_TRACKER_PAGE_SUCCESS';
export const GET_PAYOUT_TRACKER_PAGE_FAIL = 'GET_PAYOUT_TRACKER_PAGE_FAIL';
